// extracted by mini-css-extract-plugin
export default {"description":"AlertDialog_description__A4etQ","buttons":"AlertDialog_buttons__YBeBW"};